'use strict';

angular.module('bringgApp.directives').directive('envType', function () {
	return {
		templateUrl: 'scripts/directives/env_type/env-type.html',
		replace: true
	};
});
